import Experience from "../Experience";
import EventEmitter from "./EventEmitter";
import * as THREE from "three";
import { billboardEls, interactedObjects } from "../World/sets";

type CameraControlsLike = {
  update: (delta: number) => boolean;
  azimuthAngle: number;
};

type RendererLike = {
  update: () => void;
};

type StatsLike = {
  active?: boolean;
  begin: () => void;
  end: () => void;
};

export default class Time extends EventEmitter {
  experience: Experience;
  cameraControls: CameraControlsLike;
  renderer: RendererLike;
  scene: THREE.Scene;
  camera: THREE.Camera;
  stats: StatsLike;
  start: number;
  clock: THREE.Clock;
  current: number;
  elapsed: number;
  delta: number;

  constructor(
    cameraControls: CameraControlsLike,
    renderer: RendererLike,
    scene: THREE.Scene,
    camera: THREE.Camera,
    stats: StatsLike
  ) {
    super();
    this.experience = new Experience();
    this.cameraControls = cameraControls;
    this.renderer = renderer;
    this.scene = scene;
    this.camera = camera;
    this.stats = stats;
    this.start = Date.now();
    this.clock = new THREE.Clock();
    this.current = this.start;
    this.elapsed = 0;
    this.delta = this.clock.getDelta();
    window.requestAnimationFrame(() => {
      this.tick();
    });
  }

  tick = () => {
    if (this.stats.active) {
      this.stats.begin();
    }

    const delta = this.clock.getDelta();
    this.cameraControls.update(delta);
    this.trigger("tick");

    if (this.experience.sceneOperations?.autorotate) {
      this.cameraControls.azimuthAngle += 5 * delta * THREE.MathUtils.DEG2RAD;
    }

    this.experience.sceneUtils?.beginBillboardFrame?.();

    billboardEls.forEach((element) => {
      this.experience.sceneUtils?.billboardPlane?.(element);
    });

    interactedObjects.forEach((element) => {
      this.experience.sceneUtils?.billboardPlane?.(element);
    });

    if (this.stats.active) {
      this.stats.end();
    }

    requestAnimationFrame(this.tick);
    this.renderer.update();
  };
}
